import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  semiboldLabel: {
    fontWeight: 600,
  },
  installmentsSelect: {
    marginTop: theme.spacing(2),
  },
  paymentMethodCard: {
    height: '100%',
  },
  changeProducstRadioGroup: {
    '& .hst-radio-group-radios': {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    '& .hst-radio-group-error-message': {
      margin: 0,
    },
  },
  actionsGrid: {
    marginTop: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 16,
  },
  loadingContainer: {
    width: '100%',
    textAlign: 'center',
  },
  errorContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    padding: '30px 0',
  },
}));
